import Vue from 'vue'

import rowCell from './input-row-cell'
Vue.component(rowCell.name, rowCell)

export default {
    slots() {
        return [
            {
                slot: "row-cell",
                component: rowCell.name,
                condition(attrs) {
                    return attrs.col.type === 'InputColumn'
                }
            }
        ]
    },
    mixins() {
        return {
            inject: {
                form: {
                    default() {
                        console.error('Table plguin [InputColumn]: Please use it inside Form component.')
                    }
                }
            },
            props: {
                prefix: {
                    type: String
                },
                defaultInputColumnType: {
                    type: String,
                    default: 'oc-text-input'
                }
            }
        }
    }
}
